import React from 'react';

import config from 'configs/app';
import useAddChainClick from 'lib/web3/useAddChainClick';
import useProvider from 'lib/web3/useProvider';
import { WALLETS_INFO } from 'lib/web3/wallets';
import { Button } from 'toolkit/chakra/button';
import IconSvg from 'ui/shared/IconSvg';
import { useBreakpointValue } from '@chakra-ui/react';

interface Props {
  source: 'Footer' | 'Top bar';
  onAddSuccess?: () => void;
}

const NetworkAddToWallet = ({ source, onAddSuccess }: Props) => {
  const { data: { wallet } = {} } = useProvider();
  const isMobile = useBreakpointValue({ base: true, lg: false });

  const handleClick = useAddChainClick({ source, onSuccess: onAddSuccess });

  const handleInstallWallet = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    window.open('https://metamask.io/download/', '_blank');
  };

  const handleAddNetwork = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    handleClick();
  };

  if (!wallet) {
    return (
      <Button
        variant="outline"
        size="2xs"
        borderWidth="1px"
        fontWeight="500"
        color="link.primary"
        borderColor="link.primary"
        onClick={ handleInstallWallet }
        cursor="pointer"
        _hover={{
          color: 'link.primary.hover',
          borderColor: 'link.primary.hover',
        }}
      >
        <IconSvg name="wallet" boxSize={ 3 }/>
        { !isMobile && 'Install Wallet' }
      </Button>
    );
  }

  const walletInfo = WALLETS_INFO[wallet];

  return (
    <Button
      variant="outline"
      size="2xs"
      borderWidth="1px"
      fontWeight="500"
      color={ walletInfo.color }
      borderColor={ walletInfo.color }
      onClick={ handleAddNetwork }
      cursor="pointer"
      _hover={{
        color: 'link.primary.hover',
        borderColor: 'link.primary.hover',
      }}
    >
      <IconSvg name={ walletInfo.icon } boxSize={ 3 }/>
      <IconSvg name="plus" boxSize={ 2 } ml={ 1 }/>
    </Button>
  );
};

export default React.memo(NetworkAddToWallet);
